import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-featuredetection-js/ApplicationFeatures';

const fn = ($scope, submissionViewModel,StateUtils, CustomQuoteService,  $translate, $filter ) => {

    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    $scope.effectiveStateFlowModel = flowModel;
    let submissionVm = submissionViewModel();

    ctrl.init = () => {
        $scope.submissionVM = submissionViewModel();
        const currentCountry = $scope.submissionVM.baseData.accountHolder.primaryAddress.value.country;
        //INCI12142809 | unable to quote if rrdi is alpha and vehicle model is blank
        if($scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles.length > 0){
            var vehicleMake = $scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles[0].make;
            if(vehicleMake == 'alfaromeo' ){
                var alpharomeoModel_PSA_Temp = $scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles[0].alpharomeoModel_PSA_Temp;
                if(alpharomeoModel_PSA_Temp == undefined ){
                    $scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles[0].alpharomeoModel_PSA_Temp = 'Unknown';
                }
            }else if(vehicleMake == 'lancia' ){
                var LanciaModel_PSA_Temp = $scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles[0].LanciaModel_PSA_Temp;
                if(LanciaModel_PSA_Temp == undefined ){
                    $scope.submissionVM.value.lobData.puw_PSA.coverables.vehicles[0].LanciaModel_PSA_Temp = 'Unknown';
                }
            }
        }
        ctrl.getNoOfDays(currentCountry);
        //UCWAR 968
        if(window.isGatewayportalnewsubmission  != undefined)
            $scope.isGatewayportalnewsubmission = window.isGatewayportalnewsubmission ;
        else
            $scope.isGatewayportalnewsubmission = false ; 
        $scope.NoOfDaysInThePast = 0;
        $scope.NoOfDaysInTheFuture = 0;
        $scope.noOfDaysMistch = "";
        const today = new Date();
        $scope.isLoadingComplete = false
        $scope.today ={};
        $scope.futureDay ={};
        const operation = CustomQuoteService.getNoOfdays(currentCountry);
        operation.then((result) => {
            //console.log(result);
            $scope.NoOfDaysInThePast = result.noOfDaysInThePast
            $scope.NoOfDaysInTheFuture = result.noOfDaysInTheFuture
            today.setDate(today.getDate()-($scope.NoOfDaysInThePast));
            today.setHours(0, 0, 0, 0);
            $scope.today = {
                year: today.getFullYear(),
                month: today.getMonth(),
                day: today.getDate()
            };
            const futureDay = new Date();
            futureDay.setDate(futureDay.getDate()+($scope.NoOfDaysInTheFuture));
            futureDay.setHours(0, 0, 0, 0);
            $scope.futureDay = {
                    year: futureDay.getFullYear(),
                    month: futureDay.getMonth(),
                    day: futureDay.getDate()
            };

            $scope.isLoadingComplete = true;
        }).catch((err) => {
            $scope.isLoadingComplete = true;
        });
 
    };
    ctrl.next = function (callback) {
        //$scope.form.submitted = true;
        //UCWPRODENG-780
        var deliveryDateBYSettingInPast = new Date($scope.today.year, $scope.today.month, $scope.today.day)
        deliveryDateBYSettingInPast.setHours(0, 0, 0, 0);
        var deliveryDateBYSettingInFuture = new Date($scope.futureDay.year, $scope.futureDay.month, $scope.futureDay.day)
        deliveryDateBYSettingInFuture.setHours(0, 0, 0, 0);
        var effective = new Date(submissionVm.baseData.periodStartDate.value.year, submissionVm.baseData.periodStartDate.value.month, submissionVm.baseData.periodStartDate.value.day);
        effective.setHours(0, 0, 0, 0);
        if (moment(effective).isBefore(deliveryDateBYSettingInPast)) {
            $scope.noOfDaysMistch = $translate.instant('psa.quoteandbind.policy-information.DeliveryDateRule', {
                noOfDays: $scope.NoOfDaysInThePast
            })
            callback();
            return false;
        } else if (moment(effective).isAfter(deliveryDateBYSettingInFuture)) {
            $scope.noOfDaysMistch = $translate.instant('psa.quoteandbind.policy-information.DeliveryDateInFutureRule', {
                noOfDaysInFuture: $scope.NoOfDaysInTheFuture
            })
            callback();
            return false;
        }
        // if ($scope.form.valid === false) {
        //     callback();
        //     return;
        // }
        
        flowModel.next(submissionVm);
    };
    ctrl.getNoOfDays = function (currentCountry){
        var NoOfDaysInThePast = 0;
        var NoOfDaysInTheFuture = 0;
        const operation = CustomQuoteService.getNoOfdays(currentCountry);
                operation.then((result) => {
                    //console.log(result);
                    NoOfDaysInThePast = result.noOfDaysInThePast
                    NoOfDaysInTheFuture = result.noOfDaysInTheFuture
                    const today = new Date();
                    today.setDate(today.getDate()-(NoOfDaysInThePast));
                    today.setHours(0, 0, 0, 0);
                    $scope.today = {
                        year: today.getFullYear(),
                        month: today.getMonth(),
                        day: today.getDate()
                    };
                    //UCWAR-970
                    const futureDay = new Date();
                    futureDay.setDate(futureDay.getDate()+(NoOfDaysInTheFuture));
                    futureDay.setHours(0, 0, 0, 0);
                         $scope.futureDay = {
                                 year: futureDay.getFullYear(),
                                 month: futureDay.getMonth(),
                                 day: futureDay.getDate()
                    };
                });
        //return NoOfDaysInThePast;
    }
    ctrl.updateEditOption = (flagEnabled)=>{
        $scope.isGatewayportalnewsubmission = flagEnabled;
    }
    return ctrl.create($scope);

};
fn.$inject = ['$scope', 'submissionViewModel','StateUtils', 'qnb.CustomQuoteService', '$translate',  '$filter'];

export default fn;
